export default __webpack_public_path__ + "static/media/mushroomcupcakes.7e3b7752.jpg";